export default __webpack_public_path__ + "static/media/training@3x.3856516d.png";